import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketingPageHeader from "@/components/MarketingPageHeader";
import { Button } from "@/components/ui/button";
import { Globe2, Heart, Laptop, Rocket, Users, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

const perks = [
  { icon: Globe2, titleKey: "careers.perks.remote.title", descriptionKey: "careers.perks.remote.description" },
  { icon: Users, titleKey: "careers.perks.smallTeam.title", descriptionKey: "careers.perks.smallTeam.description" },
  { icon: Heart, titleKey: "careers.perks.missionDriven.title", descriptionKey: "careers.perks.missionDriven.description" },
  { icon: Rocket, titleKey: "careers.perks.moveFast.title", descriptionKey: "careers.perks.moveFast.description" },
  { icon: Laptop, titleKey: "careers.perks.equipment.title", descriptionKey: "careers.perks.equipment.description" },
  { icon: Zap, titleKey: "careers.perks.learning.title", descriptionKey: "careers.perks.learning.description" },
];

const Careers = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <MarketingPageHeader
        title={<>{t("careers.hero.titleLine1")}<br className="hidden md:block" /> {t("careers.hero.titleLine2")}</>}
        subtitle={t("careers.hero.subtitle")}
        containerClassName="max-w-4xl"
      />
      <main>
      {/* Perks */}
      <section className="container mx-auto px-4 pb-16 pt-6 max-w-5xl">
        <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground mb-10 text-center">
          {t("careers.perks.heading")}
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {perks.map((perk) => (
            <div
              key={perk.titleKey}
              className="rounded-xl bg-secondary/50 p-6"
            >
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
                <perk.icon className="w-5 h-5 text-foreground" />
              </div>
              <h3 className="font-display font-semibold text-foreground mb-1">{t(perk.titleKey)}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{t(perk.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Open Positions */}
      <section className="bg-background">
        <div className="container mx-auto px-4 py-20 max-w-4xl">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground mb-4 text-center">
            {t("careers.openings.heading")}
          </h2>
          <p className="text-center text-muted-foreground">
            {t("careers.openings.none")}
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="container mx-auto px-4 py-20 max-w-3xl text-center">
        <div className="rounded-2xl bg-secondary/50 p-10">
          <h2 className="text-xl font-display font-bold text-foreground mb-2">{t("careers.cta.heading")}</h2>
          <p className="text-muted-foreground mb-6 text-sm">
            {t("careers.cta.subtitle")}
          </p>
          <Button asChild>
            <a href="mailto:hello@jynio.co">{t("careers.cta.button")}</a>
          </Button>
        </div>
      </section>
      </main>

      <Footer />
    </div>
  );
};

export default Careers;
